import { inject as k, provide as T } from "vue";
const e = () => {
  const c = k("trackingData", {});
  return {
    getTrackingText: (n, t, i) => l("", [], n, t, i),
    provideTrackingData: (n) => {
      T("trackingData", { trackingData: n });
    },
    trackingDataProvided: c
  };
}, l = (c, a, r, n, t) => {
  var o, g;
  const i = (r == null ? void 0 : r.title) || ((o = a == null ? void 0 : a[n - 1]) == null ? void 0 : o.title) || ((g = a == null ? void 0 : a[n - 2]) == null ? void 0 : g.title);
  return [c, i, t == null ? void 0 : t.title].filter(Boolean).join(" > ");
};
export {
  l as getTrackingNavigationText,
  e as useTracking
};
